import SigninWithContent from './SigninWithContent'

export default SigninWithContent
